/**
 * AIMixingPanelWrapper Component
 * Wrapper for AI Mixing Assistant panel with suggestion handling
 */

import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { AIMixingPanel } from '../aimixing';
import { toast } from 'sonner';

export const AIMixingPanelWrapper = ({
  isOpen,
  onClose,
  tracks,
  masterVolume,
  bpm,
  projectName,
  setMasterVolume,
  updateTrack,
}) => {
  const handleApplySuggestion = (suggestion) => {
    if (suggestion.parameter === 'masterVolume') {
      // Master volume suggestion
      setMasterVolume(suggestion.suggestedValue);
      toast.success(`Master volume set to ${(suggestion.suggestedValue * 100).toFixed(0)}%`);
    } else if (suggestion.trackId) {
      // Track-specific suggestion
      const trackId = parseInt(suggestion.trackId, 10) || suggestion.trackId;
      const track = tracks.find(t => String(t.id) === String(trackId));
      if (track && suggestion.parameter && suggestion.suggestedValue !== null) {
        // Handle nested parameters (eq.bass, effects.reverb)
        if (suggestion.parameter.includes('.')) {
          const [parent, child] = suggestion.parameter.split('.');
          const currentParent = track[parent] || {};
          updateTrack(trackId, { 
            [parent]: { ...currentParent, [child]: suggestion.suggestedValue } 
          });
        } else {
          updateTrack(trackId, { [suggestion.parameter]: suggestion.suggestedValue });
        }
        toast.success(`${track.name}: ${suggestion.parameter} updated`);
      }
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed top-0 right-0 bottom-0 z-40">
          <AIMixingPanel
            tracks={tracks}
            masterVolume={masterVolume}
            bpm={bpm}
            projectName={projectName || 'Untitled Project'}
            onApplySuggestion={handleApplySuggestion}
            onClose={onClose}
            isVisible={isOpen}
          />
        </div>
      )}
    </AnimatePresence>
  );
};

export default AIMixingPanelWrapper;
